import { pathname } from "#src/config/pathname";

export enum SolutionAction {
  UPGRADE_PLAN = "SERVICE_ACTION_ENUM_UPGRADE_PLAN",
  RENEW = "SERVICE_ACTION_ENUM_RENEW",
  UNSUBSCRIBE = "SERVICE_ACTION_ENUM_UNSUBSCRIBE",
}

export const upgradeUrl: { [P in string]: string } = {
  tc_free: pathname.WORKSPACE_BILLING_UPGRADE_TRUST_CENTER,
  tc_custom_domain: pathname.WORKSPACE_BILLING_UPGRADE_TC_CUSTOM_DOMAIN,
};

export enum SolutionStatusEnum {
  ACTIVE = "SERVICE_STATUS_ENUM_ACTIVE",
  EXPIRING = "SERVICE_STATUS_ENUM_EXPIRING",
  EXPIRED = "SERVICE_STATUS_ENUM_EXPIRED",
}

export enum PaymentMethodEnum {
  BANKING = "PAYMENT_METHOD_ENUM_BANKING",
  CARD = "PAYMENT_METHOD_ENUM_CARD",
}
